module.exports = __webpack_public_path__ + "img/d2-active.dd5a632f.png";